import { createRouterReducer, createRouterMiddleware } from '@lagunovsky/redux-react-router';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
export default function configureStore(history, initialState) {
    const middleware = [thunk, createRouterMiddleware(history)];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const rootReducer = combineReducers({
        router: createRouterReducer(history),
        form: formReducer,
    });

    return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}
